module.exports = __webpack_public_path__ + "images/internal-link.071f3f9ce35f5c1d266973755b7c3e2b.svg";